import React, { useState } from "react";

const ShowMoreText = ({
    text,
    previewLength = 50,
    hasbutton = true,
    styleClass = '',
    inlineStyle={}
}) => {
    const [expanded, setExpanded] = useState(false);

    const toggle = () => setExpanded((prev) => !prev);

    if (!text) return null;

    const isLong = text.length > previewLength;
    const displayText = expanded || !isLong ? text : text.slice(0, previewLength) + "...";

    return (
        <span className={styleClass} style={inlineStyle}>
            <span>{displayText}</span>
            {isLong  &&hasbutton && (
                <button
                    type="button"
                    onClick={toggle}
                    style={{
                        background: 'none',
                        border: 'none',
                        color: '#7DCE13',
                        cursor: 'pointer',
                        padding: 0,
                        marginLeft: '5px'
                    }}
                >
                    {expanded ? 'read less' : 'read more'}
                </button>
            )}
        </span>
    );
};

export default ShowMoreText;